const FeedbackData =[
    {
        id:1,
        rating: 10,
        text: "That's how your feedback look's like",
    }
]

export default FeedbackData